<template>
  <v-list-item v-if="subscription.subscription" :to="routerLink">
    <v-list-item-avatar>
      <img :src="logoUrl" :alt="subscription.clientId" />
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ subscription.clubName }}</v-list-item-title>

      <v-list-item-subtitle>{{ subscriptionCard }}</v-list-item-subtitle>
      <v-list-item-subtitle
        class="error--text"
        v-if="
          !!isCurrentlyOutstanding && subscriptionOutstandingInvoiceAmount > 0
        "
      >
        {{ subscriptionOutstandingInvoicePriceAndUnitFormatted }} failed on
        {{ outstandingInvoiceFinalizedDate }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-list-item-action-text v-if="!isCurrentlyOutstanding">{{
        subscriptionPlanPriceFormatted
      }}</v-list-item-action-text>
      <v-icon v-if="routing" color="accent" size="16"
        >fas fa-chevron-right</v-icon
      >
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import { formatMoney, showDayMonthTimestamp } from '&/helpers.js';
import { mapGetters } from 'vuex';

export default {
  name: 'SubscriptionListItem',
  data() {
    return {};
  },
  props: {
    subscription: {
      type: Object,
      required: true
    },
    routing: {
      type: Boolean,
      required: false,
      default() {
        return true;
      }
    }
  },

  computed: {
    ...mapGetters(['outstandingSubscriptionInvoices', 'placeholderLogoSrc']),

    logoUrl() {
      return this.$store.getters.logoUrls[this.subscription.clientId]
        ? this.$store.getters.logoUrls[this.subscription.clientId]
        : this.placeholderLogoSrc;
    },
    returnCoveringPayments() {
      let total = 0;
      if (this.subscription.outstandingInvoice) {
        for (
          var i = 0;
          i < this.subscription.outstandingInvoice.lines.data.length;
          i++
        ) {
          if (
            !this.subscription.outstandingInvoice.lines.data[i].plan &&
            this.subscription.outstandingInvoice.lines.data[i].object ===
              'line_item'
          ) {
            total += this.subscription.outstandingInvoice.lines.data[i].amount;
          }
        }
      }
      return total;
    },
    subscriptionPlan() {
      return this.subscription.plan;
    },

    subscriptionStatus() {
      return this.subscription.subscription.status;
    },

    subscriptionIsCancelled() {
      return this.subscriptionStatus == 'canceled';
    },
    subscriptionCard() {
      if (this.subscriptionIsCancelled) {
        const cancellationDate = showDayMonthTimestamp(
          this.subscription.subscription.canceled_at
        );
        return `Cancelled ${cancellationDate}`;
      } else if (this.subscription.paymentMethod) {
        return `**** **** **** ${this.subscription.paymentMethod.last4}`;
      }
      return 'No active card';
    },
    subscriptionPlanPriceFormatted() {
      return formatMoney(
        this.subscriptionPlan.amount + this.returnCoveringPayments
      );
    },
    subscriptionOutstandingInvoicePriceAndUnitFormatted() {
      return formatMoney(this.subscriptionOutstandingInvoiceAmount);
    },

    subscriptionOutstandingInvoiceAmount() {
      if (this.subscription.outstandingInvoice) {
        return this.subscription.outstandingInvoice.amount_due;
      }
    },

    isCurrentlyOutstanding() {
      if (this.outstandingSubscriptionInvoices[this.subscription.clientId]) {
        return this.outstandingSubscriptionInvoices[this.subscription.clientId];
      }
    },

    outstandingInvoiceFinalizedDate() {
      if (this.isCurrentlyOutstanding)
        return showDayMonthTimestamp(
          this.isCurrentlyOutstanding.outstandingInvoice.created
        );
    },
    routerLink() {
      if (this.routing === false) {
        return undefined;
      } else {
        return {
          name: 'SubscriptionDetail',
          params: { clientId: this.subscription.clientId }
        };
      }
    }
  },

  methods: {
    formatMoney(value) {
      return formatMoney(value);
    }
  },

  mounted() {},
  updated() {},

  components: {},
};
</script>

<style lang="scss" scoped></style>
